const FAQ = [
    {
        q: "Combien coûte une intervention de serrurerie ?",
        a: "Le tarif dépend de la prestation : ouverture de porte claquée, dépannage, remplacement de serrure ou pose de porte blindée. Atelier Beauchamp vous annonce systématiquement un tarif clair lors du diagnostic téléphonique. Il est confirmé sur place avant tout démarrage. Aucun frais caché, aucune surprise.",
    },
    {
        q: "Intervenez-vous la nuit, le week-end et les jours fériés ?",
        a: "Oui, Atelier Beauchamp intervient 24h/24 et 7j/7, y compris les nuits, week-ends et jours fériés. Une vraie personne répond directement au téléphone quelle que soit l'heure.",
    },
    {
        q: "En combien de temps arrivez-vous ?",
        a: "En moyenne sous 30 minutes après votre appel. Le délai exact dépend de votre situation géographique et de la circulation. Notre véhicule équipé permet une réponse rapide dans votre commune.",
    },
    {
        q: "Allez-vous casser ma porte ou ma serrure ?",
        a: "Non. Dans 9 cas sur 10, nous ouvrons votre porte sans aucun dégât grâce à des techniques fines (carte, crochetage, impressioning). Le perçage n'est utilisé qu'en dernier recours, et toujours après votre accord.",
    },
    {
        q: "Le devis est-il vraiment gratuit ?",
        a: "Oui. Le diagnostic téléphonique et le devis sur place sont gratuits et sans engagement. Vous décidez ensuite si vous souhaitez confier l'intervention à Atelier Beauchamp.",
    },
    {
        q: "Acceptez-vous les paiements par carte bancaire ?",
        a: "Oui. Nous acceptons les espèces, la carte bancaire et les virements. Une facture détaillée vous est remise à chaque intervention.",
    },
    {
        q: "Êtes-vous agréé par les assurances ?",
        a: "Oui. Atelier Beauchamp est agréé et travaille régulièrement avec les principales compagnies d'assurance habitation. Nous vous fournissons tous les justificatifs nécessaires pour vos démarches.",
    },
    {
        q: "Quelle garantie sur le travail et les pièces installées ?",
        a: "Toutes nos interventions sont garanties. Les serrures et cylindres haute sécurité (A2P, BP) sont couverts par la garantie fabricant. Atelier Beauchamp engage également sa propre garantie sur la main-d'œuvre.",
    },
    {
        q: "Travaillez-vous avec les particuliers et les professionnels ?",
        a: "Oui. Nous intervenons aussi bien chez les particuliers (résidences, appartements, maisons) que pour les professionnels (commerces, bureaux, copropriétés, syndics).",
    },
    {
        q: "Quelles marques de serrures installez-vous ?",
        a: "Toutes les grandes marques certifiées : ABUS, Bricard, City, Dierre, DOM, Fichet, FTH Thirard, ISEO, JPM, Kaba, Medeco, Mottura, Mul-T-Lock, Picard, Pollux, Reelax, Ronis, Vachette, Viro… Nous vous conseillons la solution adaptée à votre porte, votre budget et votre niveau de risque.",
    },
    {
        q: "Posez-vous des portes blindées ?",
        a: "Oui. Atelier Beauchamp installe des blocs-portes blindés certifiés BP1, BP2 et BP3 sur mesure, avec serrures multipoints A2P intégrées. Étude technique, dépose de l'ancienne porte, pose et finitions prises en charge.",
    },
    {
        q: "Que faire en cas d'effraction ou de tentative d'effraction ?",
        a: "Appelez immédiatement le 06 49 50 18 43. Nous mettons votre porte en sécurité, expertisons les dégâts et remplaçons les éléments endommagés si nécessaire. Nous vous fournissons les justificatifs pour votre dépôt de plainte et votre assurance.",
    },
];

export default FAQ;
